export default __webpack_public_path__ + "static/media/cosmonaut.c125dc3a.png";